module.exports = __webpack_public_path__ + "cloud-3.svg?b3b52873ee00898f88625f7e5b5ab823";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud-3.svg
// module id = 154
// module chunks = 0